<div class="screen-spacer"></div>
<app-page-header class="page-header" *ngIf="(currentTaxonomyPage$ | push) as page" [page]="page"></app-page-header>
<div class="page-content">

	

	<div class="main-content" *ngIf="(items$ | push) as schools" [ngClass]="getClass() + ' ' + pageName ">

		<div class="cards-wrapper">
			<app-card-big 
				*ngFor="let school of schools" 
				class="card-wrapper" 
				[item]="school"
			></app-card-big>
		</div>
	</div>
</div>

<app-page-bottom></app-page-bottom>

